import React from "react";

const RawMaterialHeader = ({
  search,
  setSearch,
  setPage,
  setSelectCategory,
  isModuleReadWriteAccessForRawMaterial,
  handleRefresh,
  setstockType,
  setpageLimit,
  showDeletedItems,
  setShowDeletedItems,
}) => {
  const allCategories = [
    {
      name: "Vegetables",
    },
    {
      name: "Non-veg",
    },
    {
      name: "Ingredients",
    },
    {
      name: "Others",
    },
  ];

  const handleReset = () => {
    localStorage.setItem("rawMaterialCategory", "");
    setSelectCategory("");
    localStorage.setItem("rawMaterialStockType", "");
    setstockType("");
    localStorage.setItem("rawMaterialPage", 1);
    setPage(1);
    localStorage.setItem("rawMaterialPageLimit", 50);
    setpageLimit(50);
    localStorage.setItem("searchKey", "");
    setSearch("");
    setShowDeletedItems(false);
  };

  const clearSearch = () => {
    setSearch("");
    localStorage.setItem("searchKey", "");
  };

  return (
    <header className="todo-header">
      <div className="d-flex align-items-center">
        <span className="todoapp-title  link-dark">
          {showDeletedItems ? (
            <button
              className="btn btn-outline text-primary btn-md d-flex align-items-center gap-1"
              onClick={() => {
                localStorage.setItem("rawMaterialPage", 1);
                setPage(1);
                setShowDeletedItems(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <p className="mb-0">Back</p>
            </button>
          ) : (
            <h1 className="header-title-font ">All Raw Materials</h1>
          )}
          {showDeletedItems && (
            <h1 className="header-title-font ms-2">Deleted Raw Materials</h1>
          )}
          {isModuleReadWriteAccessForRawMaterial && !showDeletedItems && (
            <div className="ms-3">
              <button
                className="btn btn-sm btn-outline-light flex-shrink-0 d-lg-inline-block header-button-shadow"
                data-bs-toggle="modal"
                data-bs-target="#add_raw_material"
              >
                Add Raw Material
              </button>
            </div>
          )}
          {!showDeletedItems && (
            <div className="ms-3">
              <button
                className="btn btn-sm btn-outline-light flex-shrink-0 d-lg-inline-block header-button-shadow"
                onClick={() => {
                  localStorage.setItem("rawMaterialPage", 1);
                  setPage(1);
                  localStorage.setItem("rawMaterialStockType", "");
                  setstockType("");
                  setShowDeletedItems(true);
                }}
              >
                Show Deleted Items
              </button>
            </div>
          )}
        </span>
      </div>
      <div className="todo-options-wrap">
        <div className="todo-toolbar me-3">
          <select
            className="form-select form-select-md"
            required
            value={
              localStorage.getItem("rawMaterialCategory") === ""
                ? ""
                : localStorage.getItem("rawMaterialCategory")
            }
            onChange={(e) => {
              localStorage.setItem("rawMaterialCategory", e.target.value);
              localStorage.setItem("rawMaterialPage", 1);
              setSelectCategory(e.target.value);
            }}
          >
            <option value="">All</option>
            {allCategories?.map((cat) => {
              return (
                <option key={cat?.name} value={cat?.name}>
                  {cat?.name}
                </option>
              );
            })}
          </select>
        </div>
        {!showDeletedItems && (
          <div className="todo-toolbar me-3">
            <select
              className="form-select form-select-md"
              required
              value={
                localStorage.getItem("rawMaterialStockType") === ""
                  ? ""
                  : localStorage.getItem("rawMaterialStockType")
              }
              onChange={(e) => {
                localStorage.setItem("rawMaterialStockType", e.target.value);
                localStorage.setItem("rawMaterialPage", 1);
                setstockType(e.target.value);
              }}
            >
              <option value="">All Stock</option>
              <option value="low">Low Stock</option>
            </select>
          </div>
        )}
        <span
          className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover no-caret d-lg-inline-block me-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="dsdsd"
          data-bs-original-title="Refresh"
        >
          <span
            className="btn-icon-wrap"
            onClick={() => {
              handleRefresh();
              handleReset();
            }}
          >
            <span className="feather-icon">
              <i className="ri-refresh-line" title="Refresh business list"></i>
            </span>
          </span>
        </span>
        <div className="v-separator d-lg-inline-block d-none"></div>
        <form className="d-sm-block d-none" role="search">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={
              localStorage.getItem("searchKey") === ""
                ? ""
                : localStorage.getItem("searchKey")
            }
            onChange={(e) => {
              localStorage.setItem("searchKey", e.target.value);
              setPage(1);
              setSearch(e.target.value);
            }}
            style={{ paddingRight: "30px" }}
          />
          {search && (
            <button
              type="button"
              onClick={clearSearch}
              style={{
                position: "absolute",
                right: "30px",
                top: "48%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                padding: "0",
              }}
            >
              &times;
            </button>
          )}
        </form>
      </div>
    </header>
  );
};

export default RawMaterialHeader;
